export const LIST_CONNECTION_REQUESTS = "listConnectionRequests";
export const ACCEPT_CONNECTION_REQUEST = "acceptConnectionRequest";
export const DECLINE_CONNECTION_REQUEST = "declineConnectionRequest";
